import { useScreenMinWidth } from "src/utils/hooks/useScreenMinWidth";
import useSearch from "src/utils/hooks/useSearch";
import { useTripTransportIndex } from "src/utils/hooks/useTripTransportIndex";
import { type ReturnStage } from "src/utils/hooks/useTypedLocation";
import { SearchResultsScreen } from "../SearchResultsScreen/SearchResultsScreen";
import { TransportResults } from "../TripPlanner/TransportResults/TransportResults";

type Props = {
  returnsFlowLocation?: ReturnStage;
};

export function TransportScreen({ returnsFlowLocation }: Readonly<Props>) {
  const { isDesktop } = useScreenMinWidth();
  const transportIndex = useTripTransportIndex();
  const { searchResponse } = useSearch();

  return (
    <>
      {isDesktop ? (
        <TransportResults
          AllPlaces={<SearchResultsScreen context="transport" />}
          transportIndex={transportIndex}
          returnsFlowLocation={returnsFlowLocation}
          searchResponse={searchResponse}
        />
      ) : (
        <SearchResultsScreen context="transport" />
      )}
    </>
  );
}
